<nb-layout>
  <nb-layout-header fixed>
    <h1 routerLink="/projects" nbButton="true">DASEC</h1>
  </nb-layout-header>

  <nb-sidebar>
    <nb-accordion>

      <nb-accordion-item>
        <nb-accordion-item-header>Regions</nb-accordion-item-header>
        <nb-accordion-item-body>
          <nb-list *ngIf="!isLoading">
            <nb-list-item  *ngFor="let c of render['cols']['region']" >
              <nb-checkbox [value]="c"
                           [checked]="render['filters']['region'].includes(c)"
                           (checkedChange)="checked($event, c, 'region')">{{c}}</nb-checkbox>
            </nb-list-item>
          </nb-list>
        </nb-accordion-item-body>
      </nb-accordion-item>

    </nb-accordion>

  </nb-sidebar>

  <nb-layout-column>


    <div class="row">

      <div class="col-6">
        <nb-card>
          <nb-toggle [(checked)]="doctors_cities">By City</nb-toggle>
          <nb-card-header>Number of Doctors ( 2017 ) </nb-card-header>
          <nb-card-body>

            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && !doctors_cities"
                             [data]=" {'datasets': render['doctors'].data, 'labels': render['doctors'].labels}" ></ngx-chartjs-bar-horizontal>
            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && doctors_cities"
                                        [data]=" {'datasets': render['doctors_cities'].data, 'labels': render['doctors_cities'].labels}" ></ngx-chartjs-bar-horizontal>

          </nb-card-body>

        </nb-card>
      </div>

      <div class="col-6">
        <nb-card>
          <nb-toggle [(checked)]="population_cities">By City</nb-toggle>
          <nb-card-header>Population Count ( 2018 ) </nb-card-header>
          <nb-card-body>

            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && !population_cities"
                                        [data]=" {'datasets': render['population'].data, 'labels': render['population'].labels}" ></ngx-chartjs-bar-horizontal>
            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && population_cities"
                                        [data]=" {'datasets': render['population_cities'].data, 'labels': render['population_cities'].labels}" ></ngx-chartjs-bar-horizontal>

          </nb-card-body>
        </nb-card>
      </div>

    </div>


    <div class="row">

      <div class="col-6">
        <nb-card>
          <nb-toggle [(checked)]="menage_cities">By City</nb-toggle>
          <nb-card-header>Households ( 2018 ) </nb-card-header>
          <nb-card-body>

            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && !menage_cities"
                                        [data]=" {'datasets': render['menage'].data, 'labels': render['menage'].labels}" ></ngx-chartjs-bar-horizontal>
            <ngx-chartjs-bar-horizontal *ngIf="!isLoading && menage_cities"
                                        [data]=" {'datasets': render['menage_cities'].data, 'labels': render['menage_cities'].labels}" ></ngx-chartjs-bar-horizontal>

          </nb-card-body>
        </nb-card>
      </div>

    </div>
  </nb-layout-column>


</nb-layout>
